import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "c-magic-line c-magic-line--underline mr-10 xl:mr-15" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_c_icon = _resolveComponent("c-icon")!

  return (_openBlock(), _createElementBlock("button", {
    class: "flex items-center",
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.scroll && _ctx.scroll(...args)))
  }, [
    _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.text), 1),
    _createVNode(_component_c_icon, {
      name: "icon-scroll-to-top",
      class: "w-10 xl:w-12"
    })
  ]))
}